import { render, staticRenderFns } from "./PODelivery.vue?vue&type=template&id=4c46ad5f&scoped=true&"
import script from "./PODelivery.vue?vue&type=script&lang=js&"
export * from "./PODelivery.vue?vue&type=script&lang=js&"
import style0 from "./PODelivery.vue?vue&type=style&index=0&id=4c46ad5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46ad5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VCol,VRow,VSpacer,VTextField})
